import React, { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const LanguageHandler = ({ children }) => {
    const { i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const { lang } = useParams();

    const supportedLangs = ["uz", "ru", "en"];

    useEffect(() => {
        // If there's a lang param and it's supported
        if (lang && supportedLangs.includes(lang)) {
            if (i18n.language !== lang) {
                i18n.changeLanguage(lang);
            }
        } else {
            // No valid lang prefix in the URL param (:lang)
            // Check if the current pathname itself starts with a language code
            const pathParts = location.pathname.split("/").filter(Boolean);
            const firstPart = pathParts[0];

            if (supportedLangs.includes(firstPart)) {
                // It is a valid lang, but didn't match the :lang param for some reason
                if (i18n.language !== firstPart) {
                    i18n.changeLanguage(firstPart);
                }
            } else {
                // Truly no lang prefix, redirect
                const currentLang = i18n.language || "uz";
                const targetLang = supportedLangs.includes(currentLang) ? currentLang : "uz";

                // Construct new path, avoiding double slashes or extra prefixes
                const cleanPath = location.pathname.startsWith('/') ? location.pathname : `/${location.pathname}`;
                const newPath = `/${targetLang}${cleanPath}${location.search}${location.hash}`;
                navigate(newPath, { replace: true });
            }
        }
    }, [lang, i18n, location, navigate]);

    return children;
};

export default LanguageHandler;
